var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649",
    transform: "translate(-1228 -107)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(1228 107)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M2266.058,1395.355a9.988,9.988,0,0,1,9.042-8.967c.3-.023.6-.035.9-.035a9.946,9.946,0,0,1,7.7,3.561,10.22,10.22,0,0,1,2.281,7.421,9.156,9.156,0,0,1-2.425,5.588,24.958,24.958,0,0,1-1.959,2.031l-.11.1a3.836,3.836,0,0,0-1.694,3.222,1.386,1.386,0,0,1,1.028,1.344,1.5,1.5,0,0,1-.562,1.292,1.59,1.59,0,0,1,.567,1.3,1.308,1.308,0,0,1-.581,1.115,1.6,1.6,0,0,1,.562,1.508,1.454,1.454,0,0,1-1.526,1.2h0l-.082,0c-.222,1.449-1.479,1.566-3.21,1.566a3.876,3.876,0,0,1-2.716-.633,1.421,1.421,0,0,1-.374-.913q-.089.009-.176.009a1.477,1.477,0,0,1-1.49-1.347,1.453,1.453,0,0,1,.562-1.359,1.587,1.587,0,0,1-.572-1.3,1.3,1.3,0,0,1,.633-1.146,1.476,1.476,0,0,1-.685-1.223,1.369,1.369,0,0,1,1.081-1.338c-.017-1.988-1.265-3.075-2.473-4.126a13.37,13.37,0,0,1-1.286-1.222A10.04,10.04,0,0,1,2266.058,1395.355Zm2.637,4.741a10.4,10.4,0,0,0,2.41,2.85c1.451,1.347,2.95,2.738,2.938,5.3h1.074v-3.595c0-.208-.015-.433-.031-.651a2.176,2.176,0,0,1,.239-1.608.884.884,0,0,1,.678-.259h.056a.881.881,0,0,1,.655.274,2.2,2.2,0,0,1,.233,1.59c-.016.218-.031.443-.031.653v3.595h1.073c-.021-2.553,1.25-3.69,2.593-4.892.4-.36.818-.732,1.209-1.151a8.332,8.332,0,0,0,2.387-5.33,7.794,7.794,0,0,0-.912-4.2,8.112,8.112,0,0,0-7.205-4.495c-.141,0-.286,0-.429.011a8.184,8.184,0,0,0-7.076,4.834A9.068,9.068,0,0,0,2268.695,1400.1Z",
    transform: "translate(-1022.799 -1269.625)",
    fill: "#3c4856"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tip.a0952d0c4fc378721018dcff390b9fdc.svg";